import { create } from "zustand";

interface BrandStore {
  selectedIdx: number | null;
  drawerOpen: boolean;

  openDrawerForAdd: () => void;
  openDrawerForEdit: (idx: number) => void;
  closeDrawer: () => void;
}

export const useBrandStore = create<BrandStore>((set) => ({
  selectedIdx: null,
  drawerOpen: false,

  openDrawerForAdd: () => set({ selectedIdx: null, drawerOpen: true }),
  openDrawerForEdit: (idx) =>
    set({ selectedIdx: idx, drawerOpen: true }),
  closeDrawer: () => set({ drawerOpen: false, selectedIdx: null }),
}));
